import { Component } from '@angular/core';
import { UserRole } from 'src/app/enums/enums';
import { SharedService } from 'src/app/services/shared.service';

export interface INavItems {
  icon: string;
  path?: string;
  label: string;
  canAccessBy: number;
  children?: INavItems[];
}

export const NavOptions = [
  {
    icon: 'bi-grid',
    path: '/home',
    label: 'Dashboard',
    canAccessBy: UserRole.EMPLOYEE
  },
  {
    icon: 'bi-card-checklist',
    path: '/patient-checklist',
    label: 'Patients Calling List',
    canAccessBy: UserRole.EMPLOYEE
  },
  {
    icon: 'bi-person-heart',
    path: '/patients',
    label: 'Patient',
    canAccessBy: UserRole.EMPLOYEE
  },
  {
    icon: 'bi-list-ul',
    path: '/attorney-list',
    label: 'Attorney List',
    canAccessBy: UserRole.EMPLOYEE
  },
  {
    icon: 'bi-file-earmark-text',
    label: 'Reports',
    canAccessBy: UserRole.EMPLOYEE,
    children: [
      {
        icon: 'bi-circle',
        path: '/report/mri',
        label: 'MRI',
        canAccessBy: UserRole.EMPLOYEE
      },
      {
        icon: 'bi-circle',
        path: '/report/attorney',
        label: 'Attorney',
        canAccessBy: UserRole.EMPLOYEE
      },
      {
        icon: 'bi-circle',
        path: '/report/flag',
        label: 'Flag',
        canAccessBy: UserRole.EMPLOYEE
      },
      {
        icon: 'bi-circle',
        path: '/report/non-compliant',
        label: 'Non-Compliant',
        canAccessBy: UserRole.EMPLOYEE
      }
    ]
  },
  {
    icon: 'bi-clipboard-check',
    label: 'Appointments',
    canAccessBy: UserRole.EMPLOYEE,
    children: [
      {
        icon: 'bi-circle',
        path: '/appointments/internal-medicine',
        label: 'Internal Medicine',
        canAccessBy: UserRole.EMPLOYEE
      },
      {
        icon: 'bi-circle',
        path: '/appointments/orthopedist',
        label: 'Orthopedist',
        canAccessBy: UserRole.EMPLOYEE
      },
      {
        icon: 'bi-circle',
        path: '/appointments/neurologist',
        label: 'Neurologist',
        canAccessBy: UserRole.EMPLOYEE
      },
      {
        icon: 'bi-circle',
        path: '/appointments/range-of-motion',
        label: 'Range of Motion',
        canAccessBy: UserRole.EMPLOYEE
      },
      {
        icon: 'bi-circle',
        path: '/appointments/pain-management',
        label: 'Pain Management',
        canAccessBy: UserRole.EMPLOYEE
      }
    ]
  },
  {
    icon: 'bi-box2-heart',
    path: '/mri-facility',
    label: 'MRI Facility',
    canAccessBy: UserRole.EMPLOYEE
  },
  {
    icon: 'bi-taxi-front',
    path: '/transportation-checklist',
    label: 'Transportation List',
    canAccessBy: UserRole.EMPLOYEE
  },

  {
    icon: 'bi-person-gear',
    path: '/employee',
    label: 'Employee',
    canAccessBy: UserRole.ADMIN
  },
  {
    icon: 'bi-prescription2',
    path: '/clinic',
    label: 'Clinic',
    canAccessBy: UserRole.ADMIN
  }
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  constructor(public sharedService: SharedService) {}
  public SidebarOptions: INavItems[] = NavOptions;
}
